/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializes analytics for map.
 * @export
 * @interface SiteMapAnalytics
 */
export interface SiteMapAnalytics {
    /**
     * Site id.
     * @type {string}
     * @memberof SiteMapAnalytics
     */
    id: string;
    /**
     * Total emissions across cluster sites
     * @type {number}
     * @memberof SiteMapAnalytics
     */
    emissionCount: number;
    /**
     * Total emissions below threshold across cluster sites
     * @type {number}
     * @memberof SiteMapAnalytics
     */
    emissionsBelowThresholdCount: number;
    /**
     * Total non-detects across cluster sites
     * @type {number}
     * @memberof SiteMapAnalytics
     */
    nondetectsCount: number;
    /**
     * emissions_below_threshold_count / emission_count, or null
     * @type {number}
     * @memberof SiteMapAnalytics
     */
    emissionRatio: number | null;
    /**
     * Centroid [longitude, latitude] of cluster sites, or null
     * @type {Array<number>}
     * @memberof SiteMapAnalytics
     */
    location: Array<number> | null;
}

/**
 * Check if a given object implements the SiteMapAnalytics interface.
 */
export function instanceOfSiteMapAnalytics(value: object): value is SiteMapAnalytics {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('emissionCount' in (value as Record<string, any>)) && !('emission_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionCount'] === undefined && (value as Record<string, any>)['emission_count'] === undefined)) return false;
    if ((!('emissionsBelowThresholdCount' in (value as Record<string, any>)) && !('emissions_below_threshold_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionsBelowThresholdCount'] === undefined && (value as Record<string, any>)['emissions_below_threshold_count'] === undefined)) return false;
    if ((!('nondetectsCount' in (value as Record<string, any>)) && !('nondetects_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['nondetectsCount'] === undefined && (value as Record<string, any>)['nondetects_count'] === undefined)) return false;
    if ((!('emissionRatio' in (value as Record<string, any>)) && !('emission_ratio' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionRatio'] === undefined && (value as Record<string, any>)['emission_ratio'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function SiteMapAnalyticsFromJSON(json: any): SiteMapAnalytics {
    return SiteMapAnalyticsFromJSONTyped(json, false);
}

export function SiteMapAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteMapAnalytics {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'emissionCount': json['emission_count'],
        'emissionsBelowThresholdCount': json['emissions_below_threshold_count'],
        'nondetectsCount': json['nondetects_count'],
        'emissionRatio': json['emission_ratio'],
        'location': json['location'] == null ? null : json['location'],
    };
}

export function SiteMapAnalyticsToJSON(json: any): SiteMapAnalytics {
    return SiteMapAnalyticsToJSONTyped(json, false);
}

export function SiteMapAnalyticsToJSONTyped(value?: SiteMapAnalytics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'emission_count': value['emissionCount'],
        'emissions_below_threshold_count': value['emissionsBelowThresholdCount'],
        'nondetects_count': value['nondetectsCount'],
        'emission_ratio': value['emissionRatio'],
        'location': value['location'],
    };
}

